import './tooltip.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var TOOLTIP_BODY_MAX_HEIGHT = 240;
export var TOOLTIP_MAX_WIDTH = 480;
export var actionsContainer = '_1j1seex17-3-15-1';
export var annotationsGroupsScrollContainer = '_1j1seexc-3-15-1';
export var chevron = '_1j1seexl-3-15-1';
export var chevronRightAligned = '_1j1seexm-3-15-1';
export var divider = '_1j1seex13-3-15-1';
export var headerText = '_1j1seexu-3-15-1';
export var multiLineName = '_1j1seex12-3-15-1';
export var relativeValueStyle = '_1j1seexr-3-15-1';
export var seriesActionHeader = '_1j1seex15-3-15-1';
export var seriesActionHeaderMaxLinesVar = 'var(--_1j1seex2-3-15-1)';
export var seriesActionHeaderMultiLine = '_1j1seex16-3-15-1';
export var seriesDescriptionText = '_1j1seexz-3-15-1';
export var seriesDescriptionTextMultiLine = '_1j1seex10-3-15-1';
export var seriesDescriptionTextMultiLineWrap = '_1j1seex11-3-15-1';
export var seriesGridContainer = '_1j1seexb-3-15-1';
export var seriesHeader = '_1j1seex7-3-15-1';
export var seriesHeaderName = '_1j1seex8-3-15-1';
export var seriesHeaderValue = '_1j1seex9-3-15-1';
export var seriesItem = _7a468({defaultClassName:'_1j1seexf-3-15-1',variantClassNames:{symbolPosition:{left:'_1j1seexg-3-15-1',right:'_1j1seexh-3-15-1'},hasChevron:{true:'_1j1seexi-3-15-1'}},defaultVariants:{symbolPosition:'left',hasChevron:false},compoundVariants:[]});
export var seriesItemActive = '_1j1seexn-3-15-1';
export var seriesItemHighlighted = '_1j1seex18-3-15-1';
export var seriesItemMaxWidthVar = 'var(--_1j1seex1-3-15-1)';
export var seriesItemText = '_1j1seexo-3-15-1';
export var seriesItemWithChevron = '_1j1seexk-3-15-1';
export var seriesItemWrapper = '_1j1seexj-3-15-1';
export var seriesNameCell = '_1j1seexx-3-15-1';
export var seriesNameMaxLinesVar = 'var(--_1j1seex0-3-15-1)';
export var seriesNameText = '_1j1seexv-3-15-1';
export var seriesNameTextMultiLine = '_1j1seexp-3-15-1';
export var seriesNameTextMultiLineWrap = '_1j1seexq-3-15-1';
export var seriesOverflowContainer = '_1j1seexe-3-15-1';
export var seriesOverflowContainerBase = '_1j1seexd-3-15-1';
export var seriesValueCell = '_1j1seexy-3-15-1';
export var seriesValueText = '_1j1seexw-3-15-1';
export var seriesWrapper = '_1j1seexa-3-15-1';
export var spaceSavedForSymbolVar = 'var(--_1j1seex3-3-15-1)';
export var symbolRight = '_1j1seex14-3-15-1';
export var symbolWrapper = _7a468({defaultClassName:'_1j1seexs-3-15-1',variantClassNames:{isRight:{true:'_1j1seext-3-15-1'}},defaultVariants:{},compoundVariants:[]});
export var wrapper = _7a468({defaultClassName:'_1j1seex4-3-15-1',variantClassNames:{isInteractive:{true:'_1j1seex5-3-15-1',false:'_1j1seex6-3-15-1'}},defaultVariants:{},compoundVariants:[]});